module.exports = __webpack_public_path__ + "static/media/fades.ce9d41a2.svg";